import { ConditionTypeEnum } from '.'

export interface INumberCondition {
  /**
   * The values needed to evaluate the condition
   */
  comparison: {
    /**
     * The expected condition value
     *
     * e.g. 3
     */
    expectedValue?: number
    /**
     * The operator to evaluate the condition, e.g. (equals, does not equal, is greater than, is less than, is greater than or equal to, is less than or equal to, is empty, is not empty)
     */
    operator: NumberOperatorEnum
  }
  /**
   * The field name associated with the condition, e.g. ('stopSequence')
   */
  conditionName: string
  /**
   * The type of condition
   */
  conditionType: ConditionTypeEnum.Number
}

export enum NumberOperatorEnum {
  DOES_NOT_EQUAL = 'does not equal',
  EQUALS = 'equals',
  IS_EMPTY = 'is empty',
  IS_GREATER_THAN = 'is greater than',
  IS_GREATER_THAN_OR_EQUAL_TO = 'is greater than or equal to',
  IS_LESS_THAN = 'is less than',
  IS_LESS_THAN_OR_EQUAL_TO = 'is less than or equal to',
  IS_NOT_EMPTY = 'is not empty'
}
